/* Equal tracks (alignment audit, 2026-11-03): six links wrapped to four and two, and each flexed item
   grew to its own maximum, so the second line's bars were longer than the first's. Every bar is one
   track wide, whichever line it lands on. */
.meter {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(88px, 150px));
  justify-content: start;
  /* In a flex row beside its info control the list is as wide as the room, not as its tracks. */
  flex: 1 1 auto;
  min-width: 0;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  min-width: 0;
}

.segment {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.segment:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
  border-radius: var(--radius);
}

.bar {
  display: block;
  height: 10px;
  border: 2px solid var(--ok);
  border-radius: 3px;
  background: var(--ok);
}

.word {
  color: var(--ink-2);
  font-size: var(--t-min);
  font-weight: 650;
}

/* Hollow: the link the server named as the first break. */
.segment[data-state="unmet"] .bar {
  border-color: var(--crit);
  background: transparent;
}

.segment[data-state="unmet"] .word {
  color: var(--crit);
}

/* Dashed: the server did not establish it and did not name it either. */
.segment[data-state="unchecked"] .bar {
  border-style: dashed;
  border-color: var(--muted);
  background: transparent;
}

/* Grey: the link cannot apply to this figure. Not a failure. */
.segment[data-state="na"] .bar {
  border-color: var(--line-2);
  background: var(--panel-3);
}

.segment[data-state="na"] .word {
  color: var(--muted);
}

.segment:hover .word {
  text-decoration: underline;
}
